export default {
  title: "Lišta důležitých sdělení",
  important_message: "Důležité sdělení",
  label: "Nemáte žádné důležité sdělení.",
  message: `Účelem důležitých pruhů zpráv je, jak název napovídá, sdělit naléhavou nebo důležitou zprávu
  uživatelům. Je umístěna v horní části každé stránky a má jasně červenou barvu pozadí, aby byla co nejlépe viditelná.`,
  demo_message: "Zde by bylo Vaše důležité sdělení."
}
